import { apiGET } from './api';

export const getDonorTypes = () => {
  return apiGET(`/donor_types`);
};
